import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/manga';

export default function FeaturedManga() {
  const featured = mangas.filter((m) => m.featured).slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              精选推荐
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              热门刃牙漫画
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              读者最喜爱的刃牙系列漫画作品，点击开始你的格斗之旅
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden md:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            <span>查看全部</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((manga) => (
            <Link
              key={manga.slug}
              to={`/article/${manga.slug}`}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3 bg-background-200">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  title={`${manga.title} - 刃牙漫画在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${
                    manga.status === '连载中'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-800/80 text-background-100'
                  }`}>
                    {manga.status}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-background-50 text-xs font-medium">
                    共{manga.totalChapters}话 · 开始阅读 →
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                {manga.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <div className="flex items-center gap-0.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs text-foreground-600">{manga.rating}</span>
                </div>
                <span className="text-xs text-foreground-400">
                  {manga.views > 1000000
                    ? `${(manga.views / 10000).toFixed(0)}万阅读`
                    : `${manga.views}阅读`}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 flex md:hidden justify-center">
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 font-medium"
          >
            <span>查看全部漫画</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}